import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import swal from "sweetalert";
import { useDispatch, useSelector } from 'react-redux';
import { IghandleLogoutAndReLogin } from '../../store/instagram/instagramThunk';
import { resetigReLoginMessage } from '../../store/instagram/instagramSlice';

const BASE_URL = process.env.REACT_APP_BASE_URL;

console.log(process.env.REACT_APP_BASE_URL, "process.env.REACT_APP_BASE_URLprocess.env.REACT_APP_BASE_URL")

const InstagramError = () => {
    const [error, setError] = useState('');
    const [userId, setUserId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { igReLoginMessage } = useSelector((state) => state.instagram);

    const getQueryParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        setError(urlParams.get('error'));
        setUserId(urlParams.get('userId'));
    };

    useEffect(() => {
        getQueryParams(); // Get the parameters on component load
    }, []);

    useEffect(() => {
        if (igReLoginMessage) {
            swal({
                title: "Logout Successful",
                text: "You have successfully logged out!",
                icon: "success",
                position: "top",
                showConfirmButton: false,
                timer: 3000,
            });
            navigate('/Settings');
            dispatch(resetigReLoginMessage())
        }
    }, [igReLoginMessage, navigate]);

    const handleLogoutAndReLogin = async () => {
        if (userId) {
            setIsLoading(true);
            try {
                const response = await dispatch(IghandleLogoutAndReLogin(userId));
                if (response.meta.requestStatus === 'fulfilled') {
                    // Handle successful logout and relink, e.g., show a success message
                    swal("Success!", "You have successfully logged out and can now re-link your account.", "success");
                    navigate('/Settings');
                } else {
                    // Handle error case
                    swal("Error!", "There was an error logging out. Please try again.", "error");
                }
            } catch (error) {
                console.error("Logout and relink error:", error);
                swal("Error!", "There was an error logging out. Please try again.", "error");
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 transform transition-all duration-300">
                {/* Instagram Icon */}
                <div className="flex justify-center mb-6">
                    <div className="w-16 h-16 bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 rounded-2xl flex items-center justify-center shadow-lg">
                        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                        </svg>
                    </div>
                </div>

                {/* Title */}
                <h2 className="text-2xl font-bold text-gray-800 text-center mb-2">
                    Instagram Authentication
                </h2>
                <div className="flex items-center justify-center mb-6">
                    <div className="w-12 h-1 bg-red-500 rounded-full"></div>
                    <span className="mx-2 text-red-500 font-semibold">Error</span>
                    <div className="w-12 h-1 bg-red-500 rounded-full"></div>
                </div>

                {/* Error Message */}
                {error && (
                    <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6 rounded-r-lg">
                        <div className="flex items-center">
                            <svg className="w-5 h-5 text-red-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                            </svg>
                            <p className="text-red-700 text-sm font-medium">{error}</p>
                        </div>
                    </div>
                )}

                {/* Description */}
                <div className="text-center mb-8">
                    <p className="text-gray-600 leading-relaxed">
                        We encountered an issue with your Instagram account authentication. 
                        Would you like to log out and re-link it to your current account?
                    </p>
                </div>

                {/* Action Buttons */}
                <div className="space-y-4">
                    <button 
                        className={`w-full py-3 px-6 rounded-xl font-semibold text-white transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-#50B5FF-300 ${
                            isLoading 
                                ? 'bg-gray-400 cursor-not-allowed' 
                                : 'bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 hover:from-[#50B5FF]-600 hover:to-[#50B5FF]-700 shadow-lg hover:shadow-xl'
                        }`}
                        onClick={handleLogoutAndReLogin}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <div className="flex items-center justify-center">
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Processing...
                            </div>
                        ) : (
                            <>
                                <svg className="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                Yes, log out and re-link
                            </>
                        )}
                    </button>
                    
                    <button 
                        className="w-full py-3 px-6 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-gray-300 border border-gray-200"
                        onClick={() => navigate('/Settings')}
                        disabled={isLoading}
                    >
                        <svg className="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        Cancel
                    </button>
                </div>

                {/* Footer */}
                <div className="mt-8 pt-6 border-t border-gray-100">
                    <p className="text-xs text-gray-500 text-center">
                        Having trouble? Contact our support team for assistance.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default InstagramError;